import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Badge } from "../components/ui/badge";
import { MENU } from "../data/cafeData";

export const MenuSection = () => (
  <section id="menu" data-testid="menu-section" className="bg-[#F5EFE6] py-24 md:py-32">
    <div className="mx-auto max-w-4xl px-5 md:px-8">
      <div className="text-center">
        <p className="font-accent text-xs font-semibold uppercase tracking-[0.25em] text-[#C86D51]">
          The Craft Menu
        </p>
        <h2 className="mt-4 font-serif text-2xl font-bold tracking-tight text-[#2C1D11] sm:text-3xl lg:text-4xl">
          Brewed slow, served warm
        </h2>
        <p className="mx-auto mt-4 max-w-lg text-base text-[#6E5E53]">
          Coffee and tea, house specialties, matcha and refreshers, fresh waffles, and
          all-day halal bites. Prices in CAD.
        </p>
      </div>

      <Tabs defaultValue="espresso" className="mt-12">
        <TabsList
          data-testid="menu-tabs"
          className="flex h-auto w-full flex-wrap justify-center gap-1 bg-[#EBE2D4] p-1.5"
        >
          {MENU.map((cat) => (
            <TabsTrigger
              key={cat.id}
              value={cat.id}
              data-testid={`menu-tab-${cat.id}`}
              className="rounded-full px-4 py-2 font-accent text-xs font-semibold uppercase tracking-wider text-[#6E5E53] data-[state=active]:bg-[#2C1D11] data-[state=active]:text-[#FDFBF7] sm:text-sm sm:normal-case sm:tracking-normal"
            >
              {cat.label}
            </TabsTrigger>
          ))}
        </TabsList>

        {MENU.map((cat) => (
          <TabsContent key={cat.id} value={cat.id} className="mt-8">
            <p className="mb-6 text-center font-serif text-lg italic text-[#6E5E53]">{cat.blurb}</p>
            <div className="grid gap-x-10 gap-y-7 sm:grid-cols-2">
              {cat.items.map((item) => (
                <div
                  key={item.name}
                  data-testid={`menu-item-${item.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  className="group"
                >
                  <div className="flex items-baseline justify-between gap-3">
                    <h3 className="font-accent text-base font-semibold text-[#2C1D11] transition-colors group-hover:text-[#C86D51]">
                      {item.name}
                    </h3>
                    <span className="flex-1 border-b border-dotted border-[#3D2817]/25" />
                    <span className="font-serif text-lg font-semibold text-[#C86D51]">
                      ${item.price}
                    </span>
                  </div>
                  <p className="mt-1 text-sm leading-relaxed text-[#6E5E53]">{item.desc}</p>
                  {item.tags.length > 0 && (
                    <div className="mt-2 flex gap-1.5">
                      {item.tags.map((tag) => (
                        <Badge
                          key={tag}
                          variant="secondary"
                          className="rounded-full bg-[#6E7E65]/15 px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-[#55654D] hover:bg-[#6E7E65]/15"
                        >
                          {tag}
                        </Badge>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </TabsContent>
        ))}
      </Tabs>
    </div>
  </section>
);
